/**
 * @see https://fontawesome.com/how-to-use/with-the-api/setup/importing-icons
 */

import {dom} from '@fortawesome/fontawesome-svg-core'
import library from 'js/icons'

const FontAwesome = {library, dom};

export default FontAwesome;



// WEBPACK FOOTER //
// ./public/themes/frontend/uikit3/assets/js/vendor/font-awesome.js